module.exports = __webpack_public_path__ + "img/logo-3.fe1db4e8.png";